@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .bandChartRoot {
    width: 100%;
    height: 100%;
  }

  .plot {
    width: 100%;
    height: 180px;
  }

  .linePlot {
    stroke-width: 2;
    color: var(--border-primary);
  }

  .axisLine {
    stroke: var(--border-soft);
  }

  .axisText {
    font-family: var(--font-roboto-mono);
    @include typography-quokka;
    fill: var(--text-default);
  }
}
